/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    SgSptWinterSportsActivities: {
        id: 'qnb.spt.SgSptWinterSportsActivitiesModal.Activities',
        defaultMessage: 'Activities'
    },
    SgSptWinterSportsCoveredWithout: {
        id: 'qnb.spt.SgSptWinterSportsActivitiesModal.SgSptWinterSportsCoveredWithout',
        defaultMessage: 'Covered without Winter Sports add-on'
    },
    SgSptWinterSportsCoveredWith: {
        id: 'qnb.spt.SgSptWinterSportsActivitiesModal.SgSptWinterSportsCoveredWith',
        defaultMessage: 'Covered with Winter Sports add-on'
    },
    SgSptWinterSportsAdditionalParagraph: {
        id: 'qnb.spt.SgSptWinterSportsActivitiesModal.SgSptWinterSportsAdditionalParagraph',
        defaultMessage: 'If there are activities you intend to participate in that are not listed, please call us on 0800 015 8055 to confirm whether cover is provided.'
    },
    SgSptWinterSportsClose: {
        id: 'qnb.spt.SgSptWinterSportsActivitiesModal.SgSptWinterSportsClose',
        defaultMessage: 'Close'
    },
    ModalTitle: {
        id: 'qnb.spt.SgSptWinterSportsActivitiesModal.ModalTitle',
        defaultMessage: 'Winter Sports Activities Covered'
    }
});
